import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import moment from "moment";
import { DownIcon, EXLDownloadIcon, LeftArrow, PDFDownloadIcon, SortIcon, UpDownIcon } from "../Assets/iconshere";
import useSelection from "antd/es/table/hooks/useSelection";
import { humanReadable } from "../utils/useWindowDimensions";
import { exportMultipleChartsToPdf, generateExcel } from "../utils/pdf";
import Skeleton from "react-loading-skeleton";
import DateRangeFilter from "./DateRangeFilter";
import ReactPaginate from "react-paginate";
import TeamEngagementTable from "./TeamEngagementTable";
import apiClient from "../apiClient";

const TeamEngagement = () => {
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  if (!state) {
    navigate(`/team/dashboard/${userData.user.group.uuid}`, {
      state: { name: userData.user.group.name, avatar: userData.user.group.avatar, uuid: userData.user.group.uuid },
    });
  }
  const params = useParams();
  const queryParams = new URLSearchParams(location.search);
  const filter = queryParams.get("filter");
  const type = queryParams.get("type");
  const view = queryParams.get("view");
  const { uuid } = params;
  const [list, setList] = useState([]);
  const nameParts = userData.token?.length > 0 ? userData?.user?.name?.split(" ") : "";
  const placeholder =
    nameParts?.length > 0
      ? nameParts?.length >= 2
        ? `${nameParts[0][0]}${nameParts[1][0]}`
        : `${nameParts[0][0]}`
      : "";
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [totalVisits, setTotalVisits] = useState(0);
  const [totalUniqueVisits, setTotalUniqueVisits] = useState(0);
  const [totalTime, setTotalTime] = useState(0);
  const [avgTime, setAvgTime] = useState(0);
  const [sortBy, setSortBy] = useState(null);
  const [totalSessions, setTotalSessions] = useState(0);

  const [dates, setDates] = useState({
    start: null,
    end: null,
  });
  const [visitType, setVisitType] = useState("total");
  const [page, setPage] = useState(0);
  const limit = 15;

  const getDashboardData = async (page, limit) => {
    setLoading(true);
    try {

      const data = await apiClient.post(`${configData.config.API_URL}/api/dashboard/report/list/${type}/${uuid}`, { page, limit, dates, visitType })

      // let { data } = await axios.post(
      //   `${configData.config.API_URL}/api/dashboard/report/list/${type}/${uuid}`,
      //   { page, limit, dates, visitType },
      //   {
      //     headers: {
      //       Authorization: `Bearer ${userData.token}`,
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );

      if (type === "session") {
        let visitCount = data.users.reduce((acc, curr) => acc + curr.sessionCount, 0);
        let averageTime = data.totalSpentTime / visitCount;

        if (data.visitCounts.uniqueVisits < 15) setPage(0);
        setTotalTime(data.totalSpentTime);
        setAvgTime(averageTime);
        setTotalSessions(visitCount);
        setTotalCount(data.visitCounts.uniqueVisits);
        setList(data.users);
        setLoading(false);
      } else if (type === "visits") {
        if (data.visitCounts.totalVisits < 15 && visitType === "total") setPage(0);
        if (data.visitCounts.uniqueVisits < 15 && visitType === "unique") setPage(0);

        let totalTime = data.users.reduce((acc, curr) => acc + curr.time, 0);

        setTotalVisits(data.visitCounts.totalVisits);
        setTotalUniqueVisits(data.visitCounts.uniqueVisits);
        setTotalTime(humanReadable(totalTime));
        setAvgTime(humanReadable(totalTime / data.count));
        setTotalCount(visitType === "total" ? data.visitCounts.totalVisits : data.visitCounts.uniqueVisits);
        setList(data.users);
        setLoading(false);
      } else if (type === "eventsList") {
        if (data.allEvents.length < 15) setPage(0);

        setTotalTime(humanReadable(data.totalSpentTime));
        setAvgTime(humanReadable(data.totalSpentTime / data.allEvents.length));
        setTotalCount(data.allEvents.length);
        setList(data.allEvents);
        setLoading(false);
      } else {
        if (data.length < 15) setPage(0);

        let totalTime = data.reduce((acc, curr) => acc + curr.time, 0);

        setTotalTime(humanReadable(totalTime));
        setAvgTime(humanReadable(totalTime / data.length));
        setTotalCount(data.length);
        setList(data);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const tableData1 = [
    ["Group Name", state?.name || ""],
    ["Report Generated at :", moment().format("ll")],
  ];

  const generateDownloadData = async (type, fileType, visitType) => {
    try {

      const data = await apiClient.post(`${configData.config.API_URL}/api/dashboard/report/list/${type}/${uuid}`,  { dates, visitType })

      // let { data } = await axios.post(
      //   `${configData.config.API_URL}/api/dashboard/report/list/${type}/${uuid}`,
      //   { dates, visitType },
      //   {
      //     headers: {
      //       Authorization: `Bearer ${userData.token}`,
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );

      if (type === "visits") {
        if (visitType === "total") {
          const pdfData = [["SL No.", "Name", "Timestamp", "Platform", "Time Spent"]];

          data.users.forEach((e, index) => {
            const rowData = [index + 1, e.name, moment(e.date).format("LLL"), e.platform, humanReadable(e.time)];
            pdfData.push(rowData);
          });
          if (fileType === "pdf") exportMultipleChartsToPdf(type, tableData1, pdfData);
          if (fileType === "excel") generateExcel(type, tableData1, pdfData);
        } else {
          const pdfData = [["SL No.", "Name", "Total Visit Count", "Total Time Spent", "Average Time Spent"]];

          data.users.forEach((e, index) => {
            const rowData = [
              index + 1,
              e.name,
              e.sessionCount,
              humanReadable(e.durations.totalTime),
              humanReadable(e.durations.averageTime),
            ];
            pdfData.push(rowData);
          });
          if (fileType === "pdf") exportMultipleChartsToPdf(type, tableData1, pdfData);
          if (fileType === "excel") generateExcel(type, tableData1, pdfData);
        }
      } else if (type === "session") {
        const pdfData = [["SL No.", "Name", "Total Visit Count", "Total Time Spent", "Average Time Spent"]];

        data.users.forEach((e, index) => {
          const rowData = [
            index + 1,
            e.name,
            e.sessionCount,
            humanReadable(e.durations.totalTime),
            humanReadable(e.durations.averageTime),
          ];
          pdfData.push(rowData);
        });
        if (fileType === "pdf") exportMultipleChartsToPdf(type, tableData1, pdfData);
        if (fileType === "excel") generateExcel(type, tableData1, pdfData);
      } else if (type === "eventsList") {
        const pdfData = [["SL No.", "Event Name", "Environment", "Date", "Event Duration", "Actual Time Spent"]];

        data.allEvents.forEach((e, index) => {
          const rowData = [
            index + 1,
            e.eventName,
            e.environmentName,
            moment(e.date).format("LLL"),
            humanReadable(e.actualEventTime),
            humanReadable(e.activityDuration),
          ];
          pdfData.push(rowData);
        });
        if (fileType === "pdf") exportMultipleChartsToPdf(type, tableData1, pdfData);
        if (fileType === "excel") generateExcel(type, tableData1, pdfData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDashboardData(page, limit);
  }, [page, dates, visitType]);

  return (
    <>
      <div className="container-fluid bg-grey-main dashboard pt-2 px-3">
        <div className="container-fluid">
          <div className="row back-n-down">
            <div className="col-md-6 d-flex align-items-center">
              <button onClick={() => navigate(-1)} className="mb-0 ms-1 backbtn cursor-pointer " title="Back">
                <LeftArrow />
                Back
              </button>
            </div>
            <div className="col-md-6 d-flex align-items-center justify-content-end gap-2">
              {sortBy && (
                <button
                  className="DefaultRedBtn sortingbtn"
                  onClick={() => {
                    getDashboardData(page, limit);
                    setSortBy(null);
                  }}
                >
                  {" "}
                  <span>
                    {" "}
                    <UpDownIcon />{" "}
                  </span>{" "}
                  Clear Sorting{" "}
                </button>
              )}
              <DateRangeFilter dates={dates} setDates={setDates} />
              <button
                className="DefaultRedBtn download"
                title="Download PDF"
                onClick={() => generateDownloadData(type, "pdf", visitType)}
              >
                <PDFDownloadIcon />
              </button>
              <button
                className="DefaultRedBtn download"
                title="Download Excel"
                onClick={() => generateDownloadData(type, "excel", visitType)}
              >
                <EXLDownloadIcon />
              </button>
            </div>
          </div>
          {type == "visits" && (
            <div className="datacardesign" style={{ backgroundColor: "transparent" }}>
              <div className="row">
                <div
                  className="col-md-8 d-flex align-itmes-center h-100"
                  style={{ backgroundColor: "#fff", borderRadius: "10px" }}
                >
                  <div className="cardimages d-flex align-items-center gap-3 ps-3 p-2">
                    {loading ? (
                      <Skeleton count={1} circle height="4.5vw" width="4.5vw" />
                    ) : (
                      <>
                        {state?.avatar?.length > 0 ? (
                          <div className="groupcardesign m-0" style={{ height: "auto" }}>
                            <div className="avatarimg">
                              <img src={state?.avatar} referrerPolicy={"no-referrer"} alt="" />
                            </div>
                          </div>
                        ) : (
                          <div className="usercardesign m-0" style={{ height: "auto" }}>
                            <div className="initials-placeholder">
                              {state?.name &&
                                state.name
                                  .split(" ")
                                  .map((word, index) => (index === 0 || index === 1 ? word.charAt(0) : ""))
                                  .join("")
                                  .toUpperCase()}
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <h4 className=" group-user-name m-0">
                      {loading ? <Skeleton count={1} width="10vw" /> : <> {state?.name || ""} </>}
                    </h4>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="dashstatdata toggle-data">
                    <div
                      onClick={() => {
                        setList([]);
                        setLoading(true);
                        setVisitType("total");
                      }}
                      className={visitType == "total" ? "welcometext active" : "welcometext"}
                    >
                      <p>{loading ? <Skeleton width="5vw" /> : <> Total Visits </>}</p>
                      {loading ? <Skeleton width="5vw" /> : <h4>{totalVisits}</h4>}
                    </div>
                    <div
                      onClick={() => {
                        setList([]);
                        setLoading(true);
                        setVisitType("unique");
                      }}
                      className={visitType == "unique" ? "welcometext active" : "welcometext"}
                    >
                      <p>{loading ? <Skeleton width="5vw" /> : <> Unique Visits </>} </p>
                      {loading ? <Skeleton width="5vw" /> : <h4>{totalUniqueVisits}</h4>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {type == "eventsList" && (
            <div className="datacardesign" style={{ backgroundColor: "transparent" }}>
              <div className="row" style={{ backgroundColor: "#fff", borderRadius: "10px" }}>
                <div className="col-md-5 d-flex align-itmes-center ">
                  <div className="cardimages d-flex align-items-center gap-3 ps-2">
                    {loading ? (
                      <Skeleton count={1} circle height="4.5vw" width="4.5vw" />
                    ) : (
                      <>
                        {state?.avatar?.length > 0 ? (
                          <div className="groupcardesign m-0" style={{ height: "auto" }}>
                            <div className="avatarimg">
                              <img src={state?.avatar} referrerPolicy={"no-referrer"} alt="" />
                            </div>
                          </div>
                        ) : (
                          <div className="usercardesign m-0" style={{ height: "auto" }}>
                            <div className="initials-placeholder">
                              {state?.name &&
                                state.name
                                  .split(" ")
                                  .map((word, index) => (index === 0 || index === 1 ? word.charAt(0) : ""))
                                  .join("")
                                  .toUpperCase()}
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <h4 className=" group-user-name m-0">
                      {loading ? <Skeleton count={1} width="10vw" /> : <> {state?.name || ""} </>}
                    </h4>
                  </div>
                </div>
                <div className="col-md-7">
                  <div className="dashstatdata">
                    <div className="welcometext">
                      <p>{loading ? <Skeleton width="5vw" /> : <> Total Events </>}</p>
                      {loading ? <Skeleton width="5vw" /> : <h4>{totalCount}</h4>}
                    </div>
                    <div className="welcometext ">
                      <p>{loading ? <Skeleton width="5vw" /> : <> Total Time Spent </>} </p>
                      {loading ? <Skeleton width="5vw" /> : <h4>{totalTime}</h4>}
                    </div>
                    <div className="welcometext ">
                      <p>{loading ? <Skeleton width="5vw" /> : <> Average Time Spent </>} </p>
                      {loading ? <Skeleton width="5vw" /> : <h4>{avgTime}</h4>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {type == "session" && (
            <div className="datacardesign" style={{ backgroundColor: "transparent" }}>
              <div className="row" style={{ backgroundColor: "#fff", borderRadius: "10px" }}>
                <div className="col-md-5 d-flex align-itmes-center ">
                  <div className="cardimages d-flex align-items-center gap-3 ps-2">
                    {loading ? (
                      <Skeleton count={1} circle height="4.5vw" width="4.5vw" />
                    ) : (
                      <>
                        {state?.avatar?.length > 0 ? (
                          <div className="groupcardesign m-0" style={{ height: "auto" }}>
                            <div className="avatarimg">
                              <img src={state?.avatar} referrerPolicy={"no-referrer"} alt="" />
                            </div>
                          </div>
                        ) : (
                          <div className="usercardesign m-0" style={{ height: "auto" }}>
                            <div className="initials-placeholder">
                              {state?.name &&
                                state.name
                                  .split(" ")
                                  .map((word, index) => (index === 0 || index === 1 ? word.charAt(0) : ""))
                                  .join("")
                                  .toUpperCase()}
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <h4 className="group-user-name m-0">
                      {loading ? <Skeleton count={1} width="10vw" /> : <> {state?.name || ""} </>}
                    </h4>
                  </div>
                </div>
                <div className="col-md-7">
                  <div className="dashstatdata">
                    {type === "session" && (
                      <>
                        <div className="welcometext ">
                          <p>{loading ? <Skeleton width="5vw" /> : <> Total Sessions </>} </p>
                          {loading ? <Skeleton width="5vw" /> : <h4>{totalSessions}</h4>}
                        </div>
                        <div className="welcometext ">
                          <p>{loading ? <Skeleton width="5vw" /> : <> Total Time Spent </>} </p>
                          {loading ? <Skeleton width="5vw" /> : <h4>{humanReadable(totalTime)}</h4>}
                        </div>
                        <div className="welcometext ">
                          <p>{loading ? <Skeleton width="5vw" /> : <> Average Time Spent </>} </p>
                          {loading ? <Skeleton width="5vw" /> : <h4>{humanReadable(avgTime)}</h4>}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="container-fluid px-0">
          <TeamEngagementTable
            visitType={visitType}
            type={type}
            list={list}
            loading={loading}
            setPage={setPage}
            page={page}
            limit={limit}
            pageCount={totalCount}
            sortBy={sortBy}
            setSortBy={setSortBy}
          />
        </div>
      </div>
    </>
  );
};
export default TeamEngagement;
